import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import hotjar from "@hotjar/browser";
import { useSelector } from "react-redux";
import { RootState } from "../store";

export default function useHotjarTracking() {
  const location = useLocation();
  const { userToken, account } = useSelector((state: RootState) => state.authState);

  const getHubspotCookie = () => {
    const match = document.cookie.match(/hubspotutk=([^;]+)/);
    return match ? match[1] : null;
  };

  useEffect(() => {
    hotjar.stateChange(location.pathname);
  }, [location]);

  useEffect(() => {
    userToken &&
      account?.id &&
      hotjar.identify(account.id, { ...account, hubspotutk: getHubspotCookie() });
  }, [userToken, account]);
}
